import { post } from 'aws-amplify/api';
import { AgentApplication, AgentApplicationSchema } from '../models/agentApplication.model';
import { CreateApplicationRequest } from '../models/application.model';

export class AgentValidationError extends Error {
  constructor(message: string, public errors: string[]) {
    super(message);
    this.name = 'AgentValidationError';
  }
}

const mapToRequest = (app: CreateApplicationRequest): AgentApplication => {
  const result = AgentApplicationSchema.safeParse(app);
  if (result.success) return result.data;
  const messages = result.error.issues.map((issue) => `${String(issue.path[0])}: ${issue.message}`);
  throw new AgentValidationError('Validation error', messages);
};

export const createAgentApplication = async (app: CreateApplicationRequest): Promise<void> => {
  const body = mapToRequest(app);
  await post({
    apiName: 'applications',
    path: '/agent-applications',
    options: { body: body as any },
  }).response;
};
